module.exports = __webpack_public_path__ + "static/media/cowboy-memoji.7e798ce7.png";